import React from 'react';
import BootstrapSelect from 'components/CustomSelect/BootstrapSelect';
import MoveIcon from 'assets/svgs/actions/move.svg';
import DeleteIcon from 'assets/svgs/actions/delete.svg';
import Duplicate from 'assets/svgs/actions/duplicate.svg';
import Action from 'assets/svgs/actions/action.svg';
import ActionActive from 'assets/svgs/actions/action-active.svg';
import messages from '../messages';

const Actions = ({selected, onAction}) => {
  const actions = [
    {
      label: messages.move,
      avatar: MoveIcon,
      className: selected && selected.length === 0 ? 'disabled' : '',
      isDisabled: selected && selected.length === 0,
      _id: messages.move,
    },
    {
      label: messages.duplicate,
      avatar: Duplicate,
      className: selected && selected.length === 0 ? 'disabled' : '',
      isDisabled: selected && selected.length === 0,
      _id: messages.duplicate,
    },
    {
      label: messages.delete,
      avatar: DeleteIcon,
      className: selected && selected.length === 0 ? 'disabled' : '',
      isDisabled: selected && selected.length === 0,
      _id: messages.delete,
    },
  ];

  return (
    <BootstrapSelect
      icon={ActionActive}
      iconActive={Action}
      options={actions}
      label={messages.actions}
      onChange={(option) => {
        if (onAction) {
          onAction(option);
        }
      }}
      className="actions-btn medium"
    />
  );
};

export default Actions;
